var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-input"},[_c('input',{ref:"input",attrs:{"type":"text","autocomplete":"off","maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":_vm.inputHandle}}),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c685b60a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomInput/CustomInput.vue
// module id = null
// module chunks = 